/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Group_Level_Ups_LedeInputs */



/**
* | output |
* | --- |
* | "Said where it happened, in a message and card that look like your server." |
*
* @param {Products_Group_Level_Ups_LedeInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_group_level_ups_lede = /** @type {((inputs?: Products_Group_Level_Ups_LedeInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Group_Level_Ups_LedeInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объявление там, где это случилось, — сообщением и карточкой в стиле вашего сервера.")
	return /** @type {LocalizedString} */ ("Said where it happened, in a message and card that look like your server.")
});